// extracted by mini-css-extract-plugin
export default {"selectorFrame":"MealSelectorPrompt-module__selectorFrame___2DfK8"};